export class CharityDetailsModal {

  charityID: any = 0;
  charity_Type: any = '';
  charity_Name: any = '';
  company_Reference_Number: any = '';
  charity_Registration_Number: any = '';
  reporting_Status: any = '';
  jurisdiction_Charity: any = '';
  is_Trading: any = '';
  trading_Status: any = '';
  //date_of_Registration: any = new Date();
  //date_of_Removal: any = new Date();
  other_names: any = '';
  date_of_Registration: any = '';
  date_of_Removal: any = '';
  telephone_Number: any = '';
  email: any = '';
  addressLine1: any = '';
  addressLine2: any = '';
  addressLine3: any = '';
  addressLine4: any = '';
  city: any = '';
  county: any = '';
  country: any = '';
  postcode: any = '';
  separate_Contact_Detail: any = '';
  title_Detail: any = '';
  job_Role_Detail: any = '';
  first_Name_Detail: any = '';
  last_Name_Detail: any = '';
  telephone_Number_Detail: any = '';
  email_Detail: any = '';
  addressLine1_Detail: any = '';
  addressLine2_Detail: any = '';
  addressLine3_Detail: any = '';
  addressLine4_Detail: any = '';
  city_Detail: any = '';
  county_Detail: any = '';
  country_Detail: any = '';
  postcode_Detail: any = '';
  //last_AP_Start_Date: any = new Date();
  //last_AP_End_Date: any = new Date();
  //current_AP_Start_Date: any = new Date();
  current_AP_End_Date: any = '';
  accounting_Method: any = '';
  //financial_Year: any = '';
  //accounting_Template: any = '';
  //fund_Tracking: any = true;
  CentralUserId: any;
  UserID: any = '';
  userId: any = '';
  createdby: any;
  from_CharityCommission: any
  account_Type: any;
  report_Title: any;
  isScottish: any = '';
  professionalAdvisorsdetails: ProfessionalAdvisorsModel=new ProfessionalAdvisorsModel();
  accountDetails: AccountDetailsModal = new AccountDetailsModal();
  //trusteesDataDetails: TrusteesDataModal[] = [];
  trusteesDataDetails: any[] = [];
  constructor(init?: Partial<CharityDetailsModal>) {
    Object.assign(this, init);
  }
}

export class AccountDetailsModal {
  last_AP_Start_Date: any
  last_AP_End_Date: any
  current_AP_Start_Date: any
  current_AP_End_Date: any
  isFirst_AP:any
  financial_Year: any
  accounting_Method: any;
  accounting_Template: any;
  fund_Tracking: any
  financialPeriodsID: any
  CentralUserId: any;
  Createdby: any;
  Modifiedby: any;
  UserId: any;
  charityID: any = 0;
  account_Type: any;
  report_Title: any;
  is_Trading: any = '';
  isDormant: any;
  constructor(init?: Partial<AccountDetailsModal>) {
     Object.assign(this, init);
  }
}


  export class ProfessionalAdvisorsModel {
  accountant_Details_Name           :any ;
  accountant_Details_Address_Line_1 :any ;
  accountant_Details_Address_Line_2 :any ;
  accountant_Details_Address_Line_3 :any ;
  accountant_Details_city           :any ;
  accountant_Details_Postcode       :any ;
  banker_Details_Name               :any ;
  banker_Details_Address_Line_1     :any ;
  banker_Details_Address_Line_2     :any ;
  banker_Details_Address_Line_3     :any ;
  banker_Details_city               :any ;
  banker_Details_Postcode           :any ;
  solicitor_Details_Name            :any ;
  solicitor_Details_Address_Line_1  :any ;
  solicitor_Details_Address_Line_2  :any ;
  solicitor_Details_Address_Line_3  :any ;
  solicitor_Details_city            :any ;
  solicitor_Details_Postcode: any;
  auditors_Details_Name: any;
  auditors_Details_FirmName: any;
  auditors_Details_Address_Line_1: any;
  auditors_Details_Address_Line_2: any;
  auditors_Details_Address_Line_3: any;
  auditors_Details_city: any;
  auditors_Details_postcode: any;
  examiners_Details_Name: any;
  examiners_Details_Address_Line_1: any;
  examiners_Details_Address_Line_2: any;
  examiners_Details_Address_Line_3: any;
  examiners_Details_city: any;
  examiners_Details_postcode: any;
  CentralUserId                     : any;
  Createdby                         : any;
  Modifiedby                        : any;
  UserId                            : any;
  CharityId                         : any = 0;
  constructor(init?: Partial<ProfessionalAdvisorsModel>) {
       Object.assign(this, init);
    }
}

export class TrusteesDataModal {
  name: any;
  is_chair: boolean
  date_of_appointment: Date
  organisation_number: number
  charity_name: string
  reg_charity_number: number
  reporting_status: string
  trustee_id: number
  comissionTrustee_Id: number
  centralUserId: number
  createdby: number
  modifiedby: number
  modifiedDate: Date
  userId: number
  charityId: number
  constructor(init?: Partial<TrusteesDataModal>) {
    Object.assign(this, init);
  }
}
